<form autocomplete="off" class="form m-3" (submit)="onSubmit($event)">
  <div class="is-flex">
    <div class="is-flex is-justify-content-start py-2 mb-2">
      <label class="label mb-0">
        <span translationEditableDirective="LICENSE_TYPE">{{
          'LICENSE_TYPE' | translate
        }}</span>
        <span class="pr-1">:</span>
      </label>
      <div class="control">{{ getField(['licenseType', 'name']) || '-' }}</div>
    </div>
  </div>

  <div class="panel-group">
    <panel name="LICENSE_DETAILS">
      <div class="field is-narrow">
        <label class="label" translationEditableDirective="CATEGORY">{{
          'CATEGORY' | translate
        }}</label>
        <div class="control">
          <ng-select
            [items]="filteredCategories"
            [multiple]="false"
            [closeOnSelect]="true"
            (change)="
              handleFieldChange(
                $event?.id,
                'categoryId',
                'subcategoryConnection.subCategory'
              )
            "
            [ngClass]="{
              'is-danger': hasError('category'),
              'is-small': true
            }"
            bindLabel="name"
            bindValue="id"
            [ngModelOptions]="{ standalone: true }"
            [ngModel]="
              getField(['subcategoryConnection', 'subCategory', 'categoryId'])
            "
            [typeahead]="onCategoryAutocomplete$"
          >
          </ng-select>
        </div>
        <p
          class="help is-danger"
          *ngIf="hasError('subcategoryConnection.subCategory.categoryId')"
        >
          {{ getError('subcategoryConnection.subCategory.categoryId') }}
        </p>
      </div>
      <div *ngIf="filteredSubCategories.length" class="field is-narrow">
        <label class="label" translationEditableDirective="SUBCATEGORY">{{
          'SUBCATEGORY' | translate
        }}</label>
        <div class="control">
          <ng-select
            [items]="filteredSubCategories"
            [multiple]="false"
            [closeOnSelect]="true"
            (change)="
              handleFieldChange(
                $event ??
                  {
                    categoryId: getField([
                      'subcategoryConnection',
                      'subCategory',
                      'categoryId'
                    ])
                  },
                'subCategory',
                'subcategoryConnection'
              )
            "
            [ngClass]="{
              'is-danger': hasError('subcategoryConnection'),
              'is-small': true
            }"
            bindLabel="name"
            bindValue="id"
            [ngModelOptions]="{ standalone: true }"
            [ngModel]="getField(['subcategoryConnection', 'subCategory', 'id'])"
          >
          </ng-select>
        </div>
        <p
          class="help is-danger"
          *ngIf="hasError('subcategoryConnection.subCategory.id')"
        >
          {{ getError('subcategoryConnection.subCategory.id') }}
        </p>
      </div>
      <div *ngIf="showLogicSlots">
        <label class="label mt-5" translationEditableDirective="TYPE">{{
          'TYPE' | translate
        }}</label>
        <radio
          [options]="logicSlotsOptions"
          name="logicSlot"
          [controlled]="true"
          [ngClass]="{ 'mt-1': true }"
          [value]="getField(['subcategoryConnection', 'logicSlot', 'id'])"
          (onChange)="
            handleFieldChange($event, 'logicSlot', 'subcategoryConnection')
          "
        ></radio>
        <p
          class="help is-danger"
          *ngIf="hasError('subcategoryConnection.logicSlot')"
        >
          {{ getError('subcategoryConnection.logicSlot') }}
        </p>
      </div>
    </panel>
    <panel name="HOLDER_DETAILS">
      <div class="field" style="max-width: 400px">
        <label class="label" translationEditableDirective="HOLDER_NAME">{{
          'HOLDER_NAME' | translate
        }}</label>
        <div class="control">
          <input
            class="input is-small"
            name="name"
            type="text"
            (input)="handleFieldChange($event)"
            [value]="getField(['name'])"
            [ngClass]="{ 'is-danger': hasError('name') }"
          />
        </div>
        <p class="help is-danger" *ngIf="hasError('name')">
          {{ getError('name') }}
        </p>
      </div>
      <div class="field" style="max-width: 400px">
        <label class="label" translationEditableDirective="TYPE_OF_BUSINESS">{{
          'TYPE_OF_BUSINESS' | translate
        }}</label>
        <div class="control">
          <input
            class="input is-small"
            name="typeOfBusiness"
            type="text"
            (input)="handleFieldChange($event)"
            [value]="getField(['typeOfBusiness'])"
            [ngClass]="{ 'is-danger': hasError('typeOfBusiness') }"
          />
        </div>
        <p class="help is-danger" *ngIf="hasError('typeOfBusiness')">
          {{ getError('typeOfBusiness') }}
        </p>
      </div>
      <div class="field" style="max-width: 400px">
        <label class="label" translationEditableDirective="TIN">{{
          'TIN' | translate
        }}</label>
        <div class="control">
          <input
            class="input is-small"
            name="tin"
            type="text"
            (input)="handleFieldChange($event)"
            [value]="getField(['tin'])"
            [ngClass]="{ 'is-danger': hasError('tin') }"
          />
        </div>
        <p class="help is-danger" *ngIf="hasError('tin')">
          {{ getError('tin') }}
        </p>
      </div>

      <div class="field" style="max-width: 400px">
        <label class="label" translationEditableDirective="REGISTRANTS">{{
          'REGISTRANTS' | translate
        }}</label>
        <div class="control">
          <ng-select
            [items]="registrants"
            [multiple]="true"
            [closeOnSelect]="true"
            (change)="handleFieldChange($event, 'registrants')"
            [ngClass]="{
              'is-danger': hasError('registrants'),
              'is-small': true
            }"
            bindLabel="name"
            bindValue="id"
            [ngModelOptions]="{ standalone: true }"
            [ngModel]="registrantsValue"
            [typeahead]="onRegistrantsAutocomplete$"
          >
          </ng-select>
        </div>
        <p class="help is-danger" *ngIf="hasError('registrants')">
          {{ getError('registrants') }}
        </p>
      </div>
    </panel>
  </div>

  <panel class="mt-4 is-block" name="RELATED_ENTITY">
    <div
      class="is-flex"
      style="
        align-items: center;
        height: 50px;
        background: #f3f3f3;
        border-bottom: 0.5px solid #b7babe;
        margin: -15px;
        padding: 15px;
      "
    >
      <radio
        [options]="entityOptions"
        [controlled]="true"
        name="entityType"
        [value]="entityType"
        (onChange)="handleEntityChange($event)"
        [ngClass]="{ 'mt-0': true }"
      ></radio>
      <div
        *ngIf="entityType == 1"
        class="is-flex pl-6"
        style="align-items: center"
      >
        <label
          class="label m-0 pr-4"
          translationEditableDirective="PROPERTY_CODE"
          >{{ 'PROPERTY_CODE' | translate }}</label
        >
        <div class="control is-relative">
          <div
            class="is-inline-flex is-align-items-center"
            *ngIf="!propertyEditable"
          >
            <a
              *ngIf="!getField(['propertyConnection', 'propertyCode'])"
              (click)="propertyEditable = true"
            >
              <span
                translationEditableDirective="SET_PROPERTY"
                *ngIf="!getField(['propertyConnection', 'propertyCode'])"
                >{{ 'SET_PROPERTY' | translate }}</span
              >
            </a>
            <a
              *ngIf="!!getField(['propertyConnection', 'propertyCode'])"
              [routerLink]="['/properties', propertyId, 'details']"
            >
              <span>{{
                getField(['propertyConnection', 'propertyCode'])
              }}</span>
            </a>

            <span
              class="icon ml-2"
              style="cursor: pointer"
              (click)="propertyEditable = true"
            >
              <svg
                fill="#2196f3"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="24"
              >
                <path
                  d="M12,2C6.47,2 2,6.47 2,12C2,17.53 6.47,22 12,22C17.53,22 22,17.53 22,12C22,6.47 17.53,2 12,2M15.1,7.07C15.24,7.07 15.38,7.12 15.5,7.23L16.77,8.5C17,8.72 17,9.07 16.77,9.28L15.77,10.28L13.72,8.23L14.72,7.23C14.82,7.12 14.96,7.07 15.1,7.07M13.13,8.81L15.19,10.87L9.13,16.93H7.07V14.87L13.13,8.81Z"
                />
              </svg>
            </span>
          </div>
          <ng-select
            *ngIf="propertyEditable"
            [items]="propertiesOptions"
            [multiple]="false"
            [closeOnSelect]="true"
            (change)="
              handleFieldChange($event, 'propertyId', 'propertyConnection')
            "
            [ngClass]="{
              'is-danger': hasError('propertyConnection'),
              'is-small': true
            }"
            bindLabel="name"
            bindValue="id"
            [ngModelOptions]="{ standalone: true }"
            [ngModel]="getField(['propertyConnection', 'propertyId'])"
            [typeahead]="onPropertyAutocomplete$"
            style="min-width: 250px"
          >
          </ng-select>

          <div
            *ngIf="propertyEditable"
            class="is-flex is-align-items-center pl-2"
            style="left: 100%; top: 0; position: absolute; height: 100%"
          >
            <span
              class="icon ml-2"
              style="cursor: pointer"
              (click)="propertyEditable = false"
            >
              <svg
                width="24"
                fill="#48c845"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
              >
                <path
                  d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z"
                />
              </svg>
            </span>
            <span
              class="icon ml-2"
              style="cursor: pointer"
              (click)="propertyEditable = false"
            >
              <svg
                width="24"
                fill="#0a0a0a4d"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
              >
                <path
                  d="M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z"
                />
              </svg>
            </span>
          </div>
        </div>
        <p
          class="help is-danger"
          *ngIf="hasError('propertyConnection.propertyId')"
        >
          {{ getError('propertyConnection.propertyId') }}
        </p>
      </div>
    </div>
    <div class="pt-5" *ngIf="entityType == 1 && building">
      <label
        class="label m-0 mb-2"
        translationEditableDirective="PROPORTION_LICENSED"
        >{{ 'PROPORTION_LICENSED' | translate }}</label
      >

      <div class="mb-5 is-flex" style="align-items: center">
        <radio
          [ngClass]="{ 'm-0': true }"
          [options]="radioOptions"
          [controlled]="true"
          name="useProportion"
          [value]="getField(['propertyConnection', 'useProportion'])"
          (onChange)="
            handleFieldChange($event, 'useProportion', 'propertyConnection')
          "
        ></radio>
        <div
          *ngIf="getField(['propertyConnection', 'useProportion']) === false"
          class="field pl-4"
        >
          <div class="control has-icon-right">
            <number-input
              name="area"
              step="0.1"
              (input)="handleFieldChange($event, null, 'propertyConnection')"
              [value]="getField(['propertyConnection', 'area'])"
              [inputClass]="{
                'is-danger': hasError('propertyConnection.area'),
                input: true,
                'is-small': true
              }"
            />
            <span
              class="icon is-small is-right"
              style="position: absolute; right: 5px; top: 8px"
            >
              {{ areaUnit }}
            </span>
          </div>
          <p class="help is-danger" *ngIf="hasError('propertyConnection.area')">
            {{ getError('propertyConnection.area') }}
          </p>
        </div>
        <div
          *ngIf="getField(['propertyConnection', 'useProportion']) === true"
          class="field pl-4"
        >
          <div class="control has-icon-right">
            <number-input
              name="proportion"
              step="0.1"
              (input)="handleFieldChange($event, null, 'propertyConnection')"
              [value]="getField(['propertyConnection', 'proportion'])"
              [inputClass]="{
                'is-danger': hasError('propertyConnection.proportion'),
                input: true,
                'is-small': true
              }"
            />
            <!-- <span
              class="icon is-small is-right"
              style="position: absolute; right: 5px; top: 8px"
            >
              %
            </span> -->
          </div>
          <p
            class="help is-danger"
            *ngIf="hasError('propertyConnection.proportion')"
          >
            {{ getError('proportion') }}
          </p>
        </div>
      </div>

      <div>
        <div class="columns">
          <div class="field column is-3">
            <label class="label mb-0" translationEditableDirective="STREET">{{
              'STREET' | translate
            }}</label>
            <div class="control">
              {{ building.street ? building.street.name : '-' }}
            </div>
          </div>
          <div class="field column is-3">
            <label
              class="label mb-0"
              translationEditableDirective="STREET_NUMBER"
              >{{ 'STREET_NUMBER' | translate }}</label
            >
            <div class="control">{{ building.streetNumber || '-' }}</div>
          </div>
          <div class="field column is-3">
            <label
              class="label mb-0"
              translationEditableDirective="COMMUNITY"
              >{{ 'COMMUNITY' | translate }}</label
            >
            <div class="control">
              {{ building.community ? building.community.name : '-' }}
            </div>
          </div>
          <div class="field column is-3">
            <label class="label" translationEditableDirective="PROPERTY_TYPE">{{
              'PROPERTY_TYPE' | translate
            }}</label>
            <div class="control">
              <ng-select
                [items]="propertyTypes"
                [multiple]="false"
                [closeOnSelect]="true"
                (change)="
                  handleFieldChange(
                    $event,
                    'propertyType',
                    'propertyConnection'
                  )
                "
                [ngClass]="{
                  'is-danger': hasError('propertyConnection.propertyType'),
                  'is-small': true
                }"
                [ngModelOptions]="{ standalone: true }"
                [ngModel]="getField(['propertyConnection', 'propertyType'])"
                style="min-width: 250px"
              >
              </ng-select>
            </div>
            <p
              class="help is-danger"
              *ngIf="hasError('propertyConnection.propertyType')"
            >
              {{ getError('propertyConnection.propertyType') }}
            </p>
          </div>
        </div>
        <div class="columns">
          <div class="field column is-3">
            <label
              class="label mb-0"
              translationEditableDirective="ROOFTOP_AREA"
              >{{ 'ROOFTOP_AREA' | translate }}</label
            >
            <div class="control">{{ building.area || '-' }}</div>
          </div>
          <div class="field column is-3">
            <label
              class="label mb-0"
              translationEditableDirective="NUMBER_OF_STORIES"
              >{{ 'NUMBER_OF_STORIES' | translate }}</label
            >
            <div class="control">{{ building.numberOfStories || '-' }}</div>
          </div>
          <div class="field column is-3">
            <label
              class="label mb-0"
              translationEditableDirective="PLUS_CODE"
              >{{ 'PLUS_CODE' | translate }}</label
            >
            <div class="control">
              <a
                target="_blank"
                [href]="'https://plus.codes/' + building.plusCode"
                >{{ building.plusCode }}</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="entityType == 2">
      <div class="pt-5 pb-2">
        <div style="width: 525px">
          <lng-lat-fields
            (onLatChange)="handleFieldChange($event, 'lat')"
            (onLngChange)="handleFieldChange($event, 'lng')"
            [lng]="getField(['lng'])"
            [lat]="getField(['lat'])"
            [latError]="hasError('lat') && getError('lat')"
            [lngError]="hasError('lng') && getError('lng')"
          ></lng-lat-fields>
        </div>
      </div>

      <div class="layers-container mt-4">
        <div class="layers-row layers-row-head">
          <div translationEditableDirective="LAYER">
            {{ 'LAYER' | translate }}
          </div>
          <div translationEditableDirective="VALUE">
            {{ 'VALUE' | translate }}
          </div>
          <div></div>
        </div>
        <div
          [formGroup]="layers"
          class="layers-wrapper"
          *ngIf="activeLayers && activeLayers.length"
        >
          <div
            class="layers-row"
            formArrayName="rows"
            *ngFor="let layer of activeLayers; let i = index"
          >
            <span class="layers-row-name">{{ layer.get('name').value }}</span>
            <div [formGroupName]="i">
              <ng-select
                [items]="layer.get('features').value"
                [multiple]="false"
                [closeOnSelect]="true"
                bindLabel="label"
                bindValue="id"
                class="is-fullwidth is-small"
                formControlName="feature"
              >
              </ng-select>
            </div>
            <div>
              <button
                (click)="detect(layer.get('id').value)"
                type="button"
                class="button is-ghost is-small is-fullwidth"
                translationEditableDirective="DETECT"
                [disabled]="!hasCoordinates"
              >
                {{ 'DETECT' | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div style="width: 500px">
        <button
          type="button"
          class="button is-info is-small ml-auto mt-3 mb-2 is-block"
          style="padding-top: 1px"
          translationEditableDirective="DETECT_ALL"
          (click)="detectAll()"
          [disabled]="!hasCoordinates"
        >
          {{ 'DETECT_ALL' | translate }}
        </button>
      </div>
    </div>
  </panel>

  <panel class="mt-4 is-block" name="CONTACT_DETAILS">
    <div
      class="is-flex"
      style="
        align-items: center;
        height: 50px;
        background: #f3f3f3;
        border-bottom: 0.5px solid #b7babe;
        margin: -15px;
        padding: 15px;
      "
    >
      <span
        translationEditableDirective="SELECT_EXISTING_CONTACT"
        class="pr-2 label m-0"
      >
        {{ 'SELECT_EXISTING_CONTACT' | translate }}
      </span>
      <ng-select
        [items]="contacts"
        [multiple]="false"
        [closeOnSelect]="true"
        (change)="handleFieldChange($event, 'contact', 'contactConnection')"
        [ngClass]="{
          'is-danger': hasError('contact'),
          'is-small': true
        }"
        bindLabel="fullName"
        bindValue="id"
        [ngModelOptions]="{ standalone: true }"
        [ngModel]="contactConnectionValue"
        [typeahead]="onContactAutocomplete$"
        [compareWith]="compareFn"
        style="min-width: 250px"
      >
        <ng-template
          ng-option-tmp
          let-item="item"
          let-index="index"
          let-search="searchTerm"
        >
          <div>{{ item.fullName }} ({{ item.taxId || 'No ID' }})</div>
        </ng-template>
      </ng-select>
      <div class="pl-2">
        <button
          translationEditableDirective="OR_CREATE_NEW"
          class="button is-info m-0 is-small"
          (click)="createNewContact($event)"
          style="height: 32px"
          type="button"
        >
          {{ 'OR_CREATE_NEW' | translate }}
        </button>
      </div>

      <div
        *ngIf="hasError('contactConnection.contact')"
        class="pl-4 has-text-danger"
      >
        {{ getError('contactConnection.contact') }}
      </div>
    </div>

    <div
      class="pt-2 business-contact"
      *ngIf="getField(['contactConnection', 'contact'])"
    >
      <form-row [canDelete]="false">
        <div class="columns mb-0">
          <div class="column is-4 pb-0 pt-4">
            <div class="field">
              <label
                class="label"
                translationEditableDirective="CONTACT_TITLE"
                >{{ 'CONTACT_TITLE' | translate }}</label
              >
              <div class="control">
                <ng-select
                  [items]="contactTitles"
                  name="contactTitle"
                  [multiple]="false"
                  [closeOnSelect]="true"
                  (change)="
                    handleFieldChange(
                      $event,
                      'contactTitle',
                      'contactConnection.contact'
                    )
                  "
                  [ngClass]="{
                    'is-danger': hasError('contactTitle'),
                    'is-small': true
                  }"
                  bindLabel="name"
                  [typeahead]="onContactTitlesAutocomplete$"
                  [ngModelOptions]="{ standalone: true }"
                  [ngModel]="
                    getField(['contactConnection', 'contact', 'contactTitle'])
                  "
                  [compareWith]="compareFn"
                >
                </ng-select>
              </div>
              <p class="help is-danger" *ngIf="hasError('contactTitle')">
                {{ getError('contactTitle') }}
              </p>
            </div>
          </div>

          <div class="column is-4 pb-0 pt-4">
            <div class="field">
              <label class="label" translationEditableDirective="FIRST_NAME">{{
                'FIRST_NAME' | translate
              }}</label>
              <div class="control">
                <input
                  class="input"
                  name="firstName"
                  type="text"
                  (input)="
                    handleFieldChange($event, null, 'contactConnection.contact')
                  "
                  [value]="
                    getField(['contactConnection', 'contact', 'firstName'])
                  "
                  [ngClass]="{
                    'is-danger': hasError(
                      'contactConnection.contact.firstName'
                    ),
                    'is-small': true
                  }"
                />
              </div>
              <p
                class="help is-danger"
                *ngIf="hasError('contactConnection.contact.firstName')"
              >
                {{ getError('contactConnection.contact.firstName') }}
              </p>
            </div>
          </div>

          <div class="column is-4 pb-0 pt-4">
            <div class="field">
              <label class="label" translationEditableDirective="LAST_NAME">{{
                'LAST_NAME' | translate
              }}</label>
              <div class="control">
                <input
                  class="input"
                  name="lastName"
                  type="text"
                  (input)="
                    handleFieldChange($event, null, 'contactConnection.contact')
                  "
                  [value]="
                    getField(['contactConnection', 'contact', 'lastName'])
                  "
                  [ngClass]="{
                    'is-danger': hasError('contactConnection.contact.lastName'),
                    'is-small': true
                  }"
                />
              </div>
              <p
                class="help is-danger"
                *ngIf="hasError('contactConnection.contact.lastName')"
              >
                {{ getError('contactConnection.contact.lastName') }}
              </p>
            </div>
          </div>
        </div>

        <div class="columns mb-0">
          <div class="column is-4 pb-0 pt-4">
            <div class="field">
              <label class="label" translationEditableDirective="EMAIL">{{
                'EMAIL' | translate
              }}</label>
              <div class="control">
                <input
                  class="input"
                  name="email"
                  type="text"
                  (input)="
                    handleFieldChange($event, null, 'contactConnection.contact')
                  "
                  [value]="getField(['contactConnection', 'contact', 'email'])"
                  [ngClass]="{
                    'is-danger': hasError('email'),
                    'is-small': true
                  }"
                />
              </div>
              <p class="help is-danger" *ngIf="hasError('email')">
                {{ getError('email') }}
              </p>
            </div>
          </div>
          <div class="column is-8 pb-0 pt-4">
            <div class="field">
              <label
                class="label"
                translationEditableDirective="PHONE_NUMBERS"
                >{{ 'PHONE_NUMBERS' | translate }}</label
              >
              <div class="control">
                <tag-input
                  [secondaryPlaceholder]="'ADD_PHONE_NUMBERS' | translate"
                  placeholder=""
                  (onAdd)="onAdd($event, 'phoneNumbers')"
                  (onRemove)="onRemove($event, 'phoneNumbers')"
                  [addOnBlur]="true"
                  name="phoneNumbers"
                  [ripple]="false"
                  class="is-small"
                  [separatorKeys]="separatorKeys"
                  [ngModelOptions]="{ standalone: true }"
                  [ngModel]="
                    getField(['contactConnection', 'contact', 'phoneNumbers'])
                  "
                ></tag-input>
              </div>
              <p class="help is-danger" *ngIf="hasError('phoneNumbers')">
                {{ getError('phoneNumbers') }}
              </p>
            </div>
          </div>
        </div>

        <div class="columns mb-0">
          <div class="column is-4 pb-0 pt-4">
            <div class="field">
              <label class="label" translationEditableDirective="TAX_ID">{{
                'TAX_ID' | translate
              }}</label>
              <div class="control">
                <input
                  class="input"
                  name="taxId"
                  type="text"
                  (input)="
                    handleFieldChange($event, null, 'contactConnection.contact')
                  "
                  [value]="getField(['contactConnection', 'contact', 'taxId'])"
                  [ngClass]="{
                    'is-danger': hasError('taxId'),
                    'is-small': true
                  }"
                />
              </div>
              <p class="help is-danger" *ngIf="hasError('taxId')">
                {{ getError('taxId') }}
              </p>
            </div>
          </div>
          <div class="column is-4 pb-0 pt-4">
            <div class="field">
              <label
                class="label"
                translationEditableDirective="CONTACT_COMMENT"
                >{{ 'CONTACT_COMMENT' | translate }}</label
              >
              <div class="control">
                <input
                  class="input"
                  name="contactComment"
                  type="text"
                  (input)="
                    handleFieldChange($event, null, 'contactConnection.contact')
                  "
                  [value]="
                    getField(['contactConnection', 'contact', 'contactComment'])
                  "
                  [ngClass]="{
                    'is-danger': hasError('contactComment'),
                    'is-small': true
                  }"
                />
              </div>
              <p class="help is-danger" *ngIf="hasError('contactComment')">
                {{ getError('contactComment') }}
              </p>
            </div>
          </div>
        </div>
      </form-row>
    </div>
  </panel>

  <div class="buttons mb-4 is-justify-content-end mt-4">
    <button
      type="submit"
      translationEditableDirective="SAVE"
      class="button is-success m-0 mr-2"
      [disabled]="isLoading"
    >
      {{ 'SAVE' | translate }}
    </button>
    <div class="control">
      <a
        translationEditableDirective="CANCEL"
        class="delete editable"
        [routerLink]="['/licenses']"
      ></a>
    </div>
  </div>
</form>
